if (!customElements.get('login-form')) {
  customElements.define(
    'login-form',
    class LoginForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.emailElement = this.querySelector(".email-input");
        this.passwordElement = this.querySelector(".password-input");
        this.submitButton = this.querySelector(".login-button");
        this.errorMessage = this.querySelector(".invalid-email-message");
        this.passwordError = this.querySelector(".invalid-password-message");
        this.emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

        this.emailElement.addEventListener('change', this.validateEmail.bind(this));
        this.passwordElement.addEventListener('change', this.validatePassword.bind(this));
        this.form.addEventListener('submit', this.handleSubmit.bind(this));

        const checkbox = this.querySelector(".show-password-checkbox");
        const label = this.querySelector(".show-password-label");

        checkbox.addEventListener('click', () => {
          this.passwordElement.type =
            this.passwordElement.type === 'password' ? 'text' : 'password';
        });

        checkbox.addEventListener('keydown', (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            checkbox.click();
          }
        });

        checkbox.addEventListener('focusin', () => label.setAttribute("data-focus-active", "true"));
        checkbox.addEventListener('focusout', () => label.removeAttribute("data-focus-active"));
      }

      validateEmail() {
        const value = this.emailElement.value.trim();
        const isValid = this.emailFormat.test(value);

        if (value === "") {
          this.clearEmailValidation();
        }

        this.emailElement.setAttribute("aria-invalid", !isValid);
        this.emailElement.classList.toggle("invalid", !isValid);
        this.emailElement.classList.toggle("valid", isValid);
        this.errorMessage.style.display = isValid ? "none" : "block";

        return isValid;
      }

      validatePassword() {
        const value = this.passwordElement.value.trim();
        const isValid = value.length > 0;

        this.passwordElement.setAttribute("aria-invalid", !isValid);
        this.passwordElement.classList.toggle("invalid", !isValid);
        this.passwordElement.classList.toggle("valid", isValid);

        if (this.passwordError) {
          this.passwordError.style.display = isValid ? "none" : "block";
        }

        return isValid;
      }

      handleSubmit(event) {
        const isEmailValid = this.validateEmail();
        const isPasswordValid = this.validatePassword();

        if (!isEmailValid || !isPasswordValid) {
            if (!isEmailValid) {
                this.emailElement.focus();
            } else if (!isPasswordValid) {
                this.passwordElement.focus();
            }
            
            event.preventDefault();
        }
      }

      clearEmailValidation() {
        this.emailElement.classList.remove("invalid", "valid");
        this.emailElement.setAttribute("aria-invalid", "false");
      }
    }
  );
}
